import { LoadingIndicatorProgress } from '@ohif/ui';

export default {
  'ui.loadingIndicatorProgress': LoadingIndicatorProgress,
};
